import { ElementoService } from "../../../services/ElementoService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import ElementoForm from "../../../components/forms/ElementoForm.vue";

export default {
    components: {
        Breadcrumb,
        ElementoForm,
    },
    name: "CriarElemento",
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Elementos',
                disabled: false,
                href: '/gerenciar-elementos',
            },
            {
                text: 'Cadastro de Elemento',
                disabled: true
            }
        ],
        loading: false,
    }),
    methods: {
        async handleSave(formData) {
            try {
                this.loading = true;
                
                // Converter dados do formulário para FormData
                const postData = new FormData();
                postData.append("exercicio", formData.exercicio);
                postData.append("codigo_elemento", formData.codigoElemento);
                postData.append("descricao", formData.descricao);
                postData.append("ativo", formData.ativo ? 1 : 0);

                // Salvar o elemento
                const response = await ElementoService.store(postData);
                
                if (response) {
                    // Redirecionar para a listagem
                    this.$router.push('/gerenciar-elementos');
                } else {
                    throw new Error('Erro ao criar elemento');
                }
            } catch (error) {
                console.error('Erro ao criar elemento:', error);
                throw error;
            } finally {
                this.loading = false;
            }
        },
        
        handleCancel() {
            this.$router.push('/gerenciar-elementos');
        }
    }
};
